import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { initializeAnalytics } from './analytics-initializer';
import { AutomatedTrackingService } from './automated-tracking.service';
import { CustomEventDirective } from './custom-event/custom-event.directive';

@NgModule({
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (initializeAnalytics)(inject(AutomatedTrackingService));
        return initializerFn();
      }),
  ],
  declarations: [CustomEventDirective],
  exports: [CustomEventDirective],
})
export class SharedUtilAnalyticsModule {}
